import React, { useRef } from 'react';
import { IMenuItemResponce } from '../../../../../../Interfaces/responseTypes';
import styles from './editMenuItem.module.scss';
import useLanguagesHooks from '../../../../../../Components/Languages/setLanguage-hooks';
import useEditMenuItem from './editMenuItem-hook';
import { ClipLoader } from 'react-spinners';
import FileUploader from '../../../../../../Components/FileUploader/fileUploader';
import AuthInput from '../../../../../../Components/Inputs/AuthInput/authInput';
import { IEditMenuItemForm } from '../../../../../../Interfaces/formValue-interfaces';
import { Controller, FieldError } from 'react-hook-form';
import TextArea from '../../../../../../Components/Inputs/TextArea/textArea';
import { AccordeonArrow } from '../../../../../../Assets/Icons';
import OptionForm from '../CreateMenuItem/OptionForm/optionForm';
import { ButtonTypes, MenuItemOpionFormTypes } from '../../../../../../Interfaces/componentTypes';
import AutoComplete from '../../../../../../Components/Inputs/AutoComplete/autoComplete';
import Button from '../../../../../../Components/Button/button';

export interface IEditMenuItemProps {
    data: IMenuItemResponce,
    title: string,
    category_id: number,
    company_id: number,
    onClose: () => void,
    cb: () => void
};

const EditMenuItem: React.FC<IEditMenuItemProps> = (props) => {
    const { data, title,onClose } = props;
    const { t, activeLangSrc, activeLanguage, checkableLanguages } = useLanguagesHooks();
    const {
        fields,
        errors,
        baseURL,
        control,
        imageUrl,
        dialogRef,
        timeUnits,
        imageLoading,
        updateLoading,
        formValidator,
        showTranslations,
        update,
        register,
        onUpdate,
        setValue,
        getValues,
        addOption,
        deleteOption,
        handleFileInputChange,
        handleShowTranslations,
    } = useEditMenuItem(props)


    return (
        <div className={styles.container} ref={dialogRef}>
            <div className={styles.header}>
                <p>{title}</p>
            </div>
            <form className={styles.form}>
                <div className={styles.item}>
                    <div className={styles.uploadContainer}>
                        <div className={styles.label}>
                            <p>{t('My_Business.Create_Menu.Item_Image')}</p>
                        </div>
                        <div className={styles.imageBox}>
                            {
                                imageLoading
                                    ?
                                    <ClipLoader color="#aa002b" size={40} />
                                    :
                                    <img
                                        src={imageUrl ?? `${baseURL}${data.image}`}
                                        alt={`${imageUrl}.png`}
                                        className={styles.image}
                                    />
                            }
                        </div>
                        <FileUploader
                            id='logo'
                            handleFileInputChange={handleFileInputChange}
                            buttonTitleStyle={styles.buttonTitle}
                            buttonStyle={`${styles.uploadButton}`}
                        />
                    </div>
                </div>
                <div className={styles.item}>
                    <div className={styles.label}>
                        <img src={activeLangSrc} alt={`${activeLangSrc}.png`} />
                        <p>
                            {t('My_Business.Create_Menu.Name')}
                        </p>
                    </div>
                    <AuthInput
                        register={register}
                        registerName={`name_${activeLanguage}`}
                        labelStyle={styles.inputLabel}
                        error={errors[`name_${activeLanguage}` as keyof IEditMenuItemForm] as FieldError | undefined}
                        patternValue={/.*[A-Za-zÀ-ÖØ-öø-ÿԱ-Ֆա-ֆА-Яа-яҐґЄєІіЇїΆ-ώΑ-ωא-ת一-龯ぁ-ゔァ-ヾㄱ-ㅎㅏ-ㅣ가-힣].*/}
                    />
                </div>
                <div className={styles.item}>
                    <div className={styles.label}>
                        <img src={activeLangSrc} alt={`${activeLangSrc}.png`} />
                        <p>
                            {t('My_Business.Create_Menu.Save_Form.Description')}
                        </p>
                    </div>
                    <TextArea
                        rows={2}
                        register={register}
                        registerName={`description_${activeLanguage}`}
                        labelStyle={styles.inputLabel}
                        error={errors[`description_${activeLanguage}` as keyof IEditMenuItemForm] as FieldError | undefined}
                    />
                </div>
                <div className={styles.show} onClick={handleShowTranslations}>
                    <p>{t('My_Business.Update_Category.Show')}</p>
                    <img
                        src={AccordeonArrow}
                        alt="icon.svg"
                        className={`${styles.icon} ${showTranslations ? styles.iconRotated : ''}`}
                    />
                </div>
                {
                    showTranslations
                    &&
                    <div className={styles.translations}>
                        {checkableLanguages.map((item) => {
                            return (
                                <>
                                    <div className={styles.item} key={item.id}>
                                        <div className={styles.label}>
                                            <img src={item.icon} alt={`${item.icon}.png`} />
                                            <p>
                                                {t('My_Business.Create_Category.Title')}
                                            </p>
                                        </div>
                                        <AuthInput
                                            register={register}
                                            registerName={`name_${item.code}`}
                                            labelStyle={styles.inputLabel}
                                            error={errors[`name_${item.code}` as keyof IEditMenuItemForm] as FieldError | undefined}
                                        />
                                    </div>
                                        <div className={styles.item}>
                                            <div className={styles.label}>
                                                <img src={item.icon} alt={`${item.icon}.png`} />
                                                <p>
                                                    {t('My_Business.Create_Menu.Save_Form.Description')}
                                                </p>
                                            </div>
                                            <TextArea
                                                rows={2}
                                                register={register}
                                                registerName={`description_${item.code}`}
                                                labelStyle={styles.inputLabel}
                                                error={errors[`description_${item.code}` as keyof IEditMenuItemForm] as FieldError | undefined}
                                            />
                                        </div>
                                </>
                            )
                        })}
                    </div>
                }
                <div className={styles.formItem}>
                    <div className={styles.formItemLabel}>
                        <p>
                            {t('My_Business.Create_Menu.Option_Form.Label')}
                        </p>
                    </div>
                    <OptionForm
                        type={MenuItemOpionFormTypes.EDIT}
                        options={fields}
                        register={register}
                        control={control}
                        update={update}
                        errors={errors}
                        getValues={getValues}
                        setValue={setValue}
                        addOption={addOption}
                        deleteOption={deleteOption}
                    />
                </div>
                <div className={styles.formItem}>
                    <div className={styles.formItemLabel}>
                        <p>{t('My_Business.Create_Menu.Cooking_Time.Label')}</p>
                    </div>
                    <div className={styles.formItemBox}>
                        <div className={styles.formItemContent}>
                            <Controller
                                control={control}
                                name='cooking_time_unit'
                                render={({ field: { onChange, name, value } }) => {
                                    return (
                                        <AutoComplete
                                            value={value}
                                            name={name}
                                            onChange={onChange}
                                            placeholder={t('My_Business.Create_Menu.Cooking_Time.Type')}
                                            id='cooking_time_unit'
                                            data={timeUnits}
                                            error={errors.cooking_time_unit}
                                        />
                                    );
                                }}
                            />
                            <AuthInput
                                register={register}
                                registerName='cooking_time'
                                labelStyle={styles.inputLabel}
                                placeholder={t('My_Business.Create_Menu.Cooking_Time.Value')}
                                type='number'
                                error={errors.cooking_time}
                                required={false}
                            />
                        </div>
                    </div>
                    <div className={styles.buttonsRow}>
                        <Button
                            buttonType={ButtonTypes.Secondary}
                            title={t('Buttons.Close')}
                            type='button'
                            onClick={onClose}
                            buttonStyle={styles.closeButton}
                        />
                        <Button
                            buttonType={formValidator ? ButtonTypes.Primery : ButtonTypes.Disabled}
                            title={t('Buttons.Save')}
                            type='button'
                            onClick={onUpdate}
                            isLoading={updateLoading}
                            buttonStyle={styles.button}
                            disable={!formValidator}
                        />
                    </div>
                </div>
            </form>
        </div>
    )
}

export default EditMenuItem
